<template>
  <b-modal
    id="modal-progresso-geracao"
    ref="modal"
    v-model="visible"
    title="Processando Geração em Lote"
    no-close-on-backdrop
    no-close-on-esc
    header-bg-variant="primary"
    header-text-variant="white"
    title-tag="h5"
    title-class="text-white"
    header-close-variant="white"
    size="md"
    @hidden="onHidden"
  >
    <div class="text-center p-2">
      <div
        v-if="loading"
        class="mb-2"
      >
        <b-spinner
          variant="primary"
          large
        />
        <p class="mt-1">
          Iniciando processamento...
        </p>
      </div>

      <div v-else>
        <div class="mb-1 d-flex justify-content-between align-items-center">
          <span class="font-weight-bold">Progresso:</span>
          <span>{{ totalProcessado }} / {{ totalRegistros }}</span>
        </div>

        <b-progress
          :value="totalProcessado"
          :max="totalRegistros"
          variant="primary"
          striped
          animated
          class="mb-2"
          style="height: 20px;"
        />

        <b-row class="text-center">
          <b-col cols="4">
            <h4 class="mb-0 text-success">
              {{ totalSucesso }}
            </h4>
            <small>Sucesso</small>
          </b-col>
          <b-col cols="4">
            <h4 class="mb-0 text-warning">
              {{ totalIgnorados }}
            </h4>
            <small>Ignorado</small>
          </b-col>
          <b-col cols="4">
            <h4 class="mb-0 text-danger">
              {{ totalErros }}
            </h4>
            <small>Erros</small>
          </b-col>
        </b-row>

        <div
          v-if="status === 'CONCLUIDO'"
          class="mt-2"
        >
          <b-alert
            variant="success"
            show
            class="mb-0 mt-1"
          >
            <div class="alert-body d-flex align-items-center justify-content-center">
              <feather-icon
                icon="CheckCircleIcon"
                class="mr-1"
              />
              <span>Processamento concluído!</span>
            </div>
          </b-alert>
        </div>

        <div
          v-if="status === 'ERRO'"
          class="mt-2"
        >
          <b-alert
            variant="danger"
            show
            class="mb-0 mt-1"
          >
            <div class="alert-body d-flex align-items-center justify-content-center">
              <feather-icon
                icon="XCircleIcon"
                class="mr-1"
              />
              <span>Ocorreu um erro no processamento. Verifique os logs.</span>
            </div>
          </b-alert>
        </div>
      </div>
    </div>

    <template #modal-footer>
      <b-button
        v-if="status === 'CONCLUIDO' || status === 'ERRO'"
        variant="primary"
        @click="finalizar"
      >
        Ver Relatório Detalhado
      </b-button>
      <b-button
        v-else
        variant="outline-secondary"
        @click="fechar"
      >
        Fechar e rodar em Background
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BProgress, BSpinner, BRow, BCol, BButton, BAlert,
} from 'bootstrap-vue'
import valorFaixaVigenciaServices from '@/api/financial/valorFaixaVigenciaServices'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BModal, BProgress, BSpinner, BRow, BCol, BButton, BAlert,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    logId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      visible: this.value,
      loading: true,
      status: 'PROCESSANDO',
      totalRegistros: 0,
      totalProcessado: 0,
      totalSucesso: 0,
      totalIgnorados: 0,
      totalErros: 0,
      polling: null,
      fullLog: null,
    }
  },
  watch: {
    value(val) {
      this.visible = val
      if (val && this.logId) {
        this.startPolling()
      }
    },
    visible(val) {
      this.$emit('input', val)
    },
  },
  methods: {
    startPolling() {
      this.resetData()
      this.fetchStatus()
      this.polling = setInterval(this.fetchStatus, 5000)
    },
    resetData() {
      this.loading = true
      this.status = 'PROCESSANDO'
      this.totalRegistros = 0
      this.totalProcessado = 0
      this.totalSucesso = 0
      this.totalIgnorados = 0
      this.totalErros = 0
      this.fullLog = null
      if (this.polling) clearInterval(this.polling)
    },
    async fetchStatus() {
      if (!this.logId) return
      try {
        const { data } = await valorFaixaVigenciaServices.findLogById(this.logId)
        this.fullLog = data
        this.totalRegistros = data.totalRegistros || 0
        this.totalProcessado = data.totalProcessado || 0
        this.totalSucesso = data.totalSucesso || 0
        this.totalIgnorados = data.totalIgnorados || 0
        this.totalErros = data.totalErros || 0
        this.status = data.status
        this.loading = false

        if (this.status === 'CONCLUIDO' || this.status === 'ERRO' || this.status === 'ABORTADO') {
          clearInterval(this.polling)
          if (this.status === 'CONCLUIDO') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Geração Concluída',
                icon: 'CheckIcon',
                variant: 'success',
                text: `Processamento do lote ${this.logId} finalizado com sucesso!`,
              },
            })
          }
        }
      } catch (err) {
        console.error('Erro no polling do log', err)
      }
    },
    finalizar() {
      this.visible = false
      this.$emit('finished', this.fullLog)
    },
    fechar() {
      this.visible = false
      if (this.polling) clearInterval(this.polling)
    },
    onHidden() {
      if (this.polling) clearInterval(this.polling)
    },
  },
}
</script>

<style scoped>
::v-deep .modal-header .close {
  color: #fff !important;
  text-shadow: none !important;
  opacity: 0.8;
}

::v-deep .modal-header .close:hover {
  opacity: 1;
}
</style>
